import React from "react";
import { Labels } from "@/components/Editor";
import {NeoFrame, MagicFrame, KittenLoveFrame} from "@/components/frames";

const FRAME_MAP = {
    neo: NeoFrame,
    magic: MagicFrame,
    cat: KittenLoveFrame,
}

const getWidgetType = (config) => {
    return config.form.find((field) => field.name === 'widget').value
}

const getWidgetColor = (config) => {
    return config.form.find((field) => field.name === 'color').value
}

export const Frame = ({ config }) => {
    const Widget = FRAME_MAP[getWidgetType(config)]
    const color = getWidgetColor(config)

    return (
        <Widget color={color}>
            <Labels config={config} color={color}/>
        </Widget>
    );
}
